import Api from '@/utils/api'

const mixin = {
  methods: {
    $api(uri, base) {
      return new Api(uri, base)
    },
  },
}

export default {
  install(Vue) {
    Vue.mixin(mixin)
  },
}
